// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__CrHRG","listHeader":"Admin_listHeader__VbBFs","list":"Admin_list__MXQr4"};